/* eslint-disable no-irregular-whitespace */
/* eslint-disable no-useless-escape */
import { RootState } from "app/store";
import { validatePassword } from "common/validatePassword";
import { validatePostalCode } from "common/validatePostalCode";
import { validateTelephoneNumber } from "common/validateTelephoneNumber";

export const selectInputValidationErrors = (state: RootState) => {
  // 必須項目のチェック
  const hasErrorEmptyEmail = state.signup.apps.email === "";
  const hasErrorEmptyCountry = state.signup.apps.country === "";
  const hasErrorEmptyName =
    state.signup.apps.familyName === "" || state.signup.apps.firstName === "";
  const hasErrorEmptyCompany = state.signup.apps.company.trim() === "";
  const hasErrorEmptyState = state.signup.apps.state === "";
  const hasErrorEmptyCity = state.signup.apps.city === "";

  const hasErrorIncorrectEmail =
    (state.signup.apps.email as string).match(/^[^@]+@[^@]+$/)?.length !== 1;
  const hasErrorNotMatchEmail =
    state.signup.apps.email !== state.signup.apps.emailCheck;

  // パスワード・確認パスワードのバリデーション
  const {
    hasErrorEmptyPassword,
    hasErrorIncorrectPassword,
    hasErrorNotMatchPassword,
  } = validatePassword(
    state.signup.apps.password,
    state.signup.apps.passwordCheck
  );

  const hasErrorFirstNameFurigana =
    state.signup.apps.firstNameFurigana === ""
      ? false
      : (state.signup.apps.firstNameFurigana as string).match(/^[ァ-ヶー　]+$/)
          ?.length !== 1;

  const hasErrorFamilyNameFurigana =
    state.signup.apps.familyNameFurigana === ""
      ? false
      : (state.signup.apps.familyNameFurigana as string).match(/^[ァ-ヶー　]+$/)
          ?.length !== 1;

  const hasErrorIncorrectNameFurigana =
    hasErrorFirstNameFurigana || hasErrorFamilyNameFurigana;

  const isEmptyCompanyFurigana = state.signup.apps.companyFurigana === "";
  const hasErrorIncorrectCompanyFurigana = isEmptyCompanyFurigana
    ? false
    : (state.signup.apps.companyFurigana as string).match(/^[ァ-ヶー　]+$/)
        ?.length !== 1;

  const { hasErrorEmptyPostalCode, hasErrorIncorrectPostalCode } =
    validatePostalCode(state.signup.apps.postalCode);

  const hasErrorIncorrectTelephoneNumber = validateTelephoneNumber(
    state.signup.apps.companyTel
  );

  return {
    hasErrorEmptyEmail,
    hasErrorEmptyPassword,
    hasErrorEmptyCountry,
    hasErrorEmptyName,
    hasErrorEmptyCompany,
    hasErrorEmptyPostalCode,
    hasErrorEmptyState,
    hasErrorEmptyCity,
    hasErrorIncorrectEmail,
    hasErrorNotMatchEmail,
    hasErrorIncorrectPassword,
    hasErrorNotMatchPassword,
    hasErrorIncorrectNameFurigana,
    hasErrorIncorrectCompanyFurigana,
    hasErrorIncorrectPostalCode,
    hasErrorIncorrectTelephoneNumber,
  };
};

export const selectEmail = (state: RootState) => state.signup.apps.email;
export const selectEmailCheck = (state: RootState) =>
  state.signup.apps.emailCheck;
export const selectPassword = (state: RootState) => state.signup.apps.password;
export const selectPasswordCheck = (state: RootState) =>
  state.signup.apps.passwordCheck;
export const selectCountry = (state: RootState) => state.signup.apps.country;
export const selectFamilyName = (state: RootState) =>
  state.signup.apps.familyName;
export const selectFirstName = (state: RootState) =>
  state.signup.apps.firstName;
export const selectFamilyNameFurigana = (state: RootState) =>
  state.signup.apps.familyNameFurigana;
export const selectFirstNameFurigana = (state: RootState) =>
  state.signup.apps.firstNameFurigana;
export const selectCompany = (state: RootState) => state.signup.apps.company;
export const selectCompanyFurigana = (state: RootState) =>
  state.signup.apps.companyFurigana;
export const selectOffice = (state: RootState) => state.signup.apps.office;
export const selectDdepartment = (state: RootState) =>
  state.signup.apps.department;
export const selectPosition = (state: RootState) => state.signup.apps.position;
export const selectJobType = (state: RootState) => state.signup.apps.jobType;
export const selectCompanyTel = (state: RootState) =>
  state.signup.apps.companyTel;
export const selectPostalCode = (state: RootState) =>
  state.signup.apps.postalCode;
export const selectState = (state: RootState) => state.signup.apps.state;
export const selectCity = (state: RootState) => state.signup.apps.city;
export const selectAddress = (state: RootState) => state.signup.apps.address;
export const selectBuildingName = (state: RootState) =>
  state.signup.apps.buildingName;
export const selectPostalError = (state: RootState) =>
  state.signup.apps.postalError;
export const selectReCaptchaSiteKey = (state: RootState) =>
  state.signup.apps.reCaptchaSiteKey;
export const selectPageState = (state: RootState) =>
  state.signup.apps.pageState;
export const selectMarket_Status = (state: RootState) =>
  state.signup.apps.market_status;
